import { TdeliveryMassiveState } from '@src/reducers/deliveriesMassive';
import type { RootState } from '@src/store/reduxstore';

const selectDeliveriesMassive = (state: RootState): TdeliveryMassiveState =>
  state.deliveriesMassive;

export default selectDeliveriesMassive;
